import {
  GETOPERATIONLOGSLIST_SUCCESS,
  GETOPERATIONLOGSLIST_FAILED,
  RESET_GETOPERATIONLOGSLIST,
  LOADING_GETOPERATIONLOGSLIST,
  NETWORK_ERROR_GETOPERATIONLOGSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETOPERATIONLOGSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETOPERATIONLOGSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETOPERATIONLOGSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETOPERATIONLOGSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETOPERATIONLOGSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
